export enum GiftProductType {
  Virtual = 'virtual',
  Existing = 'existing',
  FuelDiscount = 'fuelDiscount',
  PredictionTicket = 'prediction_ticket',
  DrawingNumber = 'drawing_number',
  SpinTicket = 'spin_ticket',
}

export namespace GiftProductType {
  /** Mesmos títulos do ProductTypeSelectionModal, para o filtro não divergir do cadastro. */
  export const translateType = (type: GiftProductType): string => {
    switch (type) {
      case GiftProductType.Virtual:
        return "Produto Virtual";
      case GiftProductType.Existing:
        return "Produto Existente";
      case GiftProductType.FuelDiscount:
        return "Desconto no Abastecimento";
      case GiftProductType.PredictionTicket:
        return "Direito ao Palpite (Bolão)";
      case GiftProductType.DrawingNumber:
        return "Número da Sorte (Sorteio)";
      case GiftProductType.SpinTicket:
        return "Giro na Roleta";
      default:
        return "";
    }
  };

  export const giftProductTypeChoices = Object.values(GiftProductType)
    .filter(x => typeof x === "string")
    .map((type) => ({
      id: type,
      name: GiftProductType.translateType(type as GiftProductType),
    }));
}
